import React from 'react'
import styles from './TableContainer.module.scss'
import { Props } from './types'
import { presets } from './presets'

const TableContainer = (props: Props) => {
  const {
    headerComponent,
    children,
    preset = 'primary'
  } = props

  return (
    <div className={presets[preset]}>
      {headerComponent}
      <div className={styles.body}>
        {children}
      </div>
    </div>
  )
}

export default TableContainer
